export default {
    activities_tab_title: 'Activities',
    activities_tab_controller: 'Controller',
    activities_tab_action: 'Action',
    activities_tab_created_at: 'Created At',
    activities_tab_type: 'Type',
    activities_tab_change: 'Change',
    activities_tab_created_by: 'Created By',
    activities_tab_search_by_controller: 'Search by Controller',
    activities_tab_show_change: 'Show Change',
    activities_tab_platform: 'Platform',
    activities_tab_method: 'Method',
    activities_tab_username: "Username",
    activities_tab_title_vidfleet_compare: "Configuration Changes",
    activities_tab_entity_id: "Entity Id",
    activities_tab_url: "Url",
    activities_tab_no_changes: "No changes"
};
